/**
 * TRUTH_MARKER Utility
 * 
 * Objective: Expose silent decisions where reality diverges.
 * RULES:
 * 1. Non-conditional (must log).
 * 2. Standardized format.
 * 3. Visually distinct in console.
 */

window.__TRUTH_MARKERS = window.__TRUTH_MARKERS || [];

export const TRUTH_MARKER = (name, module, status) => {
    const timestamp = new Date().toISOString();
    const entry = { name, module, timestamp, status };

    // 1. Console Log (Impossible to miss)
    const color = status === 'PASS' ? 'background: #27ae60; color: white' : 'background: #c0392b; color: white';
    console.log(
        `%c [TRUTH_MARKER] | ${name.padEnd(20)} | ${module.padEnd(10)} | ${status.padEnd(5)} | ${timestamp} `,
        `${color}; font-weight: bold; border-radius: 3px; padding: 2px 5px;`
    );

    // 2. Global Registry (For data capture)
    window.__TRUTH_MARKERS.push(entry);

    // 3. Optional Overlay Log (if div exists)
    const overlay = document.getElementById('truth-sweep-overlay');
    if (overlay) {
        const line = document.createElement('div');
        line.textContent = `${name} | ${module} | ${status}`;
        line.style.color = status === 'PASS' ? '#2ecc71' : '#e74c3c';
        line.style.borderBottom = '1px solid #333';
        overlay.appendChild(line);
    }
};
